import {
  DisplayType,
  FieldOrigin,
  FieldTypeEnum,
  KeyValueFormattingModel,
  KeyValueRestrictionModel,
} from '@models/module/fields/enums';
import { ScreenFieldFormattingModel } from '@models/module/fields/main/screenFieldFormattingModel';

export interface ScreenFieldModel {
  id?: number;
  customFieldId?: number;
  systemFieldName?: string;
  name: string;
  label: string;
  typeId?: FieldTypeEnum;
  displayTypeId?: DisplayType;
  expression?: string;
  formattings: KeyValueFormattingModel[];
  restrictions: KeyValueRestrictionModel[];
  x: number;
  y: number;
  cols: number;
  rows: number;
  annotation?: string;
  canRemove: boolean;
  fieldOrigin: FieldOrigin;
  isFilter: boolean;
  isContractSystemField: boolean;
  isSystemField: boolean;
  currentDateTime: boolean;
  weatherDateId?: number;
  weatherLocationId?: number;
  labelFormatting: ScreenFieldFormattingModel;
  valueFormatting: ScreenFieldFormattingModel;
  isRequired?: boolean;
}
